// client/src/coms/workspace/SplitPane.js
// The second pane of the split view. It only ever shows a text conversation (channel or direct message):
// activities, video and voice keep a single instance in the main pane, so nothing expensive is duplicated.
import React from 'react';
import ChatView from '../views/ChatView';
import SocialView from '../views/SocialView';

const noop = () => {};

export default function SplitPane({ item, items, user, server, chatNameById, focused, mode, onSelect, onSwap, onToggleMode, onClose, onOpenInMain, canSwap }) {
  const title = item ? item.title : 'Choose a conversation';
  return (
    <>
      <div className="vx-pane-header" data-testid="split-pane-header">
        <div className="vx-pane-header-title">
          <span aria-hidden="true" style={{ opacity: 0.6 }}>
            {item && item.kind === 'dm' ? '@' : '#'}
          </span>
          <label className="vx-visually-hidden" htmlFor="vx-split-select">
            Conversation in the split pane
          </label>
          <select
            id="vx-split-select"
            className="vx-pane-select"
            value={item ? item.id : ''}
            onChange={(e) => onSelect(e.target.value)}
            data-testid="split-pane-select"
            title={item && item.serverName ? `${title} — ${item.serverName}` : title}
          >
            {!item ? <option value="">Choose a conversation</option> : null}
            {items
              .filter((it) => !it.isVoice)
              .map((it) => (
                <option key={it.id} value={it.id}>
                  {it.kind === 'dm' ? '@' : '#'}
                  {it.title}
                  {it.serverName ? ` · ${it.serverName}` : ''}
                </option>
              ))}
          </select>
          {focused ? <span className="vx-pane-typing">Typing here</span> : null}
        </div>
        <button type="button" className="vx-icon-btn" onClick={onSwap} disabled={!canSwap} title="Swap panes" aria-label="Swap panes" data-testid="split-swap">
          ⇄
        </button>
        <button
          type="button"
          className="vx-icon-btn"
          onClick={onToggleMode}
          title={mode === 'down' ? 'Show side by side' : 'Show one above the other'}
          aria-label={mode === 'down' ? 'Split right' : 'Split below'}
          data-testid="split-orientation"
        >
          {mode === 'down' ? '◫' : '⬒'}
        </button>
        <button type="button" className="vx-icon-btn" onClick={onClose} title="Close split view" aria-label="Close split view" data-testid="split-close">
          ✕
        </button>
      </div>
      {!item ? (
        <div className="vx-pane-empty">Pick a conversation to show beside the main view.</div>
      ) : item.kind === 'channel' && item.isVoice ? (
        <div className="vx-pane-empty">
          Voice channels open in the main view, so your call is never duplicated.
          <button type="button" className="vx-btn" onClick={() => onOpenInMain(item.id)}>
            Open in main view
          </button>
        </div>
      ) : item.kind === 'channel' ? (
        item.server && item.channel ? (
          <ChatView key={item.id} server={item.server} channel={item.channel} user={user} chatNameById={chatNameById} memoryKey={item.id} autoFocus={focused} />
        ) : (
          <div className="vx-pane-empty">This conversation is not available.</div>
        )
      ) : (
        <SocialView
          key={item.id}
          server={server}
          user={user}
          socialSection="dms"
          onSelectSection={noop}
          selectedThreadId={item.tab.t}
          onSelectThreadId={noop}
        />
      )}
    </>
  );
}
